<template>
    
<transition name="modal">

    <template v-for="key in keys">

        <component :is="key | componentName" :key="key" v-if="modals[key]" :params="modals[key]" v-on:close="onClose(key)" />
    
    </template>

</transition>

</template>

<script>

import Vue from 'vue'

export default {

    components: {
        'com-account-profile-blog-create': () => import('./account/profile/blog/Create'),
        'com-account-profile-blog-edit': () => import('./account/profile/blog/Edit'),
        'com-account-profile-blog-delete': () => import('./account/profile/blog/Delete'),
        'com-account-profile-offers-create': () => import('./account/profile/offers/Create'),
        'com-account-profile-offers-edit': () => import('./account/profile/offers/Edit'),
        'com-account-profile-offers-delete': () => import('./account/profile/offers/Delete'),
        'com-account-profile-events-create': () => import('./account/profile/events/Create'),
        'com-account-profile-events-edit': () => import('./account/profile/events/Edit'),
        'com-account-profile-events-delete': () => import('./account/profile/events/Delete'),
        'com-account-profile-people-create': () => import('./account/profile/people/Create'),
        'com-account-profile-people-edit': () => import('./account/profile/people/Edit'),
        'com-account-profile-people-delete': () => import('./account/profile/people/Delete'),
        'com-account-profile-photos-create': () => import('./account/profile/photos/Create'),
        'com-account-profile-photos-edit': () => import('./account/profile/photos/Edit'),
        'com-account-profile-photos-delete': () => import('./account/profile/photos/Delete'),
        'com-account-profile-vacancies-create': () => import('./account/profile/vacancies/Create'),
        'com-account-profile-vacancies-edit': () => import('./account/profile/vacancies/Edit'),
        'com-account-profile-vacancies-delete': () => import('./account/profile/vacancies/Delete'),
        'com-account-profile-prices-create': () => import('./account/profile/prices/Create'),
        'com-account-profile-prices-edit': () => import('./account/profile/prices/Edit'),
        'com-account-profile-prices-delete': () => import('./account/profile/prices/Delete'),
        'com-review-respond': () => import('./review/Respond'),
        'com-review-report': () => import('./review/Report'),
        'com-review-delete': () => import('./review/Delete'),
        'com-vacancy-apply': () => import('./vacancy/Apply'),
        'com-share': () => import('./Share')
    },
    
    data: function() {

        return {
            keys: [
                'account/profile/blog/create',
                'account/profile/blog/edit',
                'account/profile/blog/delete',
                'account/profile/offers/create',
                'account/profile/offers/edit',
                'account/profile/offers/delete',
                'account/profile/events/create',
                'account/profile/events/edit',
                'account/profile/events/delete',
                'account/profile/people/create',
                'account/profile/people/edit',
                'account/profile/people/delete',
                'account/profile/photos/create',
                'account/profile/photos/edit',
                'account/profile/photos/delete',
                'account/profile/vacancies/create',
                'account/profile/vacancies/edit',
                'account/profile/vacancies/delete',
                'account/profile/prices/create',
                'account/profile/prices/edit',
                'account/profile/prices/delete',
                'review/respond',
                'review/report',
                'review/delete',
				'vacancy/apply',
				'share'
            ],
            modals: {}
        }

    },

    created: function() {

        this.$pubsub.$on('modal.open', this.onOpen.bind(this))
        this.$pubsub.$on('modal.close', this.onClose.bind(this))

    },

    beforeDestroy: function() {

        this.$pubsub.$off('modal.open', this.onOpen.bind(this))
        this.$pubsub.$off('modal.close', this.onClose.bind(this))

    },

    methods: {

        onOpen: function(e) {

            Vue.set(this.modals, e.name, e)

        },

        onClose: function(name) {

            Vue.set(this.modals, name, false)

        }

    }
    
}

</script>

<style>

.is-desktop .modal-enter-active,
.is-tablet .modal-enter-active {
	animation: menu-slide 100ms;
}

.is-desktop .modal-leave-active,
.is-tablet .modal-leave-active {
	animation: menu-slide 100ms reverse;
}

@keyframes menu-slide {
	from {
		transform: translateX(376px);
	}
	to {
		transform: translateX(0px);
	}
}

</style>